import { Container } from "@mui/material";
import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import Medium from "../../../assets/images/medium.png"
import Twitter from "../../../assets/images/twitter.png"
import Telegram from "../../../assets/images/telegram.png"

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Home",
      link: "/#home",
    },
    {
      title: "About Us",
      link: "#about",
    },
    {
      title: "Tokenomics",
      link: "#tokenomics",
    },
    {
      title: "ETH to Arbitrum Bridge",
      link: "/#",
      target: "blank"
    },

    {
      title: <img src={Medium}/>,
      link: "/#",
      target: "blank",
    },
    {
      title: <img src={Twitter}/>,
      link: "/#",
      target: "blank",
    },
    {
      title: <img src={Telegram}/>,
      link: "/#",
      target: "blank",
    },
  ];
  return (
    <Container maxWidth="xl">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </Container>
  );
};

export default LockerMenu;
